// extracted by mini-css-extract-plugin
export default {"control":"Product_control__gO4JY","richText":"Product_richText__Lu+yM"};